var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.421,34.244l-15.757-6.555c-0.002-0.001-0.003-0.001-0.005-0.002l-0.007-0.003c-0.035-0.015-0.073-0.02-0.108-0.033 c-0.087-0.031-0.174-0.062-0.266-0.081c-0.1-0.02-0.202-0.026-0.304-0.031c-0.031-0.001-0.059-0.009-0.09-0.009 s-0.06,0.008-0.09,0.009c-0.102,0.005-0.204,0.011-0.304,0.031c-0.092,0.018-0.179,0.05-0.266,0.081 c-0.036,0.013-0.073,0.018-0.108,0.033l-0.007,0.003c-0.002,0.001-0.003,0.001-0.005,0.002l-14.987,6.235l-15-6.24 c-0.617-0.256-1.321-0.188-1.878,0.183c-0.556,0.371-0.89,0.995-0.89,1.664v30.378c0,0.808,0.486,1.536,1.232,1.847l15.754,6.555 c0.003,0.001,0.005,0.002,0.008,0.003l0.006,0.002c0.038,0.016,0.078,0.022,0.116,0.035c0.084,0.029,0.167,0.06,0.255,0.078 c0.262,0.053,0.531,0.053,0.793,0c0.088-0.018,0.171-0.049,0.255-0.078c0.038-0.013,0.078-0.02,0.116-0.035l0.006-0.002 c0.003-0.001,0.005-0.002,0.008-0.003l14.986-6.235l15,6.241c0.247,0.103,0.509,0.153,0.769,0.153c0.39,0,0.776-0.113,1.109-0.336 c0.557-0.371,0.891-0.995,0.891-1.664V36.09C73.652,35.283,73.166,34.554,72.421,34.244z M42.116,37.424l11.768-4.896v26.046 l-11.768,4.897V37.424z M26.348,32.529l11.768,4.896v26.047l-11.768-4.896V32.529z M69.652,63.472l-11.769-4.897V32.529 l11.769,4.896V63.472z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.40adfda0cf373a8e47e6917c53dd591a.svg";
export { ForwardRef as ReactComponent };